var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInputClear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99935,
    cy: 10.0001,
    r: 8.33333,
    fill: "#CFD6D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0307 12.97C12.2896 13.2289 12.7093 13.2289 12.9683 12.97C13.2272 12.7111 13.2272 12.2913 12.9683 12.0324L10.9372 10.0013L12.9684 7.97006C13.2273 7.71115 13.2273 7.29138 12.9684 7.03246C12.7094 6.77355 12.2897 6.77355 12.0308 7.03246L9.99955 9.06366L7.96772 7.03183C7.70881 6.77292 7.28903 6.77292 7.03012 7.03183C6.77121 7.29074 6.77121 7.71052 7.03012 7.96943L9.06195 10.0013L7.03022 12.033C6.77131 12.2919 6.77131 12.7117 7.03022 12.9706C7.28913 13.2295 7.70891 13.2295 7.96782 12.9706L9.99955 10.9389L12.0307 12.97Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInputClear);
export default __webpack_public_path__ + "static/media/icon-input-clear.d764da52d59ba333643aca2f7de811b2.svg";
export { ForwardRef as ReactComponent };